import React from 'react';
import {useTranslation} from 'react-i18next';

import {Button, InlineNotification} from '@veneer/core';

const LicenseValidateSuccess = ({onProceed}: {onProceed: () => void}): JSX.Element => {
    const {t} = useTranslation(['licenses']);

    return (
        <>
            <InlineNotification
                closeButton={false}
                type="positive"
                title={t('licenses:csvImportValidateSuccess', 'CSV content is valid')}
                i18n={{close: t('licenses:close', 'Close')}}
            />
            <Button onClick={onProceed}>{t('licenses:proceed', 'Proceed')}</Button>
        </>
    );
};

export default LicenseValidateSuccess;
